import {
  SelectionState,
  Modifier,
} from 'draft-js';

export default function replaceText({
  contentState, key, start, end, text,
}) {
  const rangeToReplace = new SelectionState({
    anchorKey: key,
    anchorOffset: start,
    focusKey: key,
    focusOffset: end,
  });

  const newContentState = Modifier
    .replaceText(contentState, rangeToReplace, text)
    .set('selectionBefore', contentState.getSelectionBefore())
    .set('selectionAfter', contentState.getSelectionAfter());

  return newContentState;
}
